(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dwil-collection-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dwil-collection-catalog')) {
  customElements.define('dwil-collection-catalog', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const ready = () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true, signal: this.cleanup.signal});
      else queueMicrotask(ready);
    }
    initialize() {
      if (!this.isConnected || this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.sort = this.querySelector('[name="catalog_sort"]');
      this.defaultSort = this.sort.value;
      this.top = this.querySelector('[data-catalog-top]');
      this.bottom = this.querySelector('[data-catalog-bottom]');
      const feed = this.querySelector('[data-catalog-feed]');
      if (feed) {
        this.original = Array.from(feed.querySelectorAll('.dc-catalog-item'));
        this.results = this.original;
        this.total = Number(feed.dataset.total);
      }
      this.size = Number(this.dataset.size);
      this.page = 1;
      this.cache ||= new Map();
      if (feed && !feed.dataset.next) this.cache.set(this.dataset.source + '|' + this.defaultSort, this.original);
      const signal = this.cleanup.signal;
      this.form.addEventListener('submit', event => event.preventDefault(), {signal});
      this.form.addEventListener('change', () => this.update(), {signal});
      this.form.addEventListener('reset', event => {
        event.preventDefault();
        this.form.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
        this.sort.value = this.defaultSort;
        this.update();
      }, {signal});
      this.sort.addEventListener('change', () => this.update(), {signal});
      this.querySelector('[data-previous]').addEventListener('click', () => this.changePage(-1), {signal});
      this.querySelector('[data-catalog-next]').addEventListener('click', () => this.changePage(1), {signal});
      this.media = matchMedia('(min-width: 990px)');
      this.media.addEventListener('change', () => this.setSidebar(), {signal});
      this.setSidebar();
      this.render();
    }
    setSidebar() { this.querySelector('.dc-catalog-sidebar').open = this.media.matches; }
    async loadCollection(url, sort, signal) {
      const key = url + '|' + sort;
      if (this.cache.has(key)) return this.cache.get(key);
      const items = [];
      let next = new URL(url, location.origin);
      next.searchParams.set('section_id', 'dwil-collection-catalog');
      next.searchParams.set('sort_by', sort);
      const seen = new Set();
      while (next) {
        if (next.origin !== location.origin || seen.has(next.href)) throw new Error('Invalid pagination');
        seen.add(next.href);
        const response = await fetch(next.href, {signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Catalog request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = doc.querySelector('[data-catalog-feed]');
        if (!feed) throw new Error('Catalog unavailable');
        for (const item of feed.querySelectorAll('.dc-catalog-item')) {
          const oldPrefix = 'dwil-collection-catalog-' + item.dataset.id;
          const newPrefix = this.dataset.owner + '-' + item.dataset.id;
          for (const el of item.querySelectorAll('[id],[for],[aria-controls],[aria-labelledby],[href]')) {
            for (const attr of ['id','for','aria-controls','aria-labelledby','href']) {
              const value = el.getAttribute(attr);
              if (value?.includes(oldPrefix)) el.setAttribute(attr, value.replaceAll(oldPrefix, newPrefix));
            }
          }
          item.querySelector('.quick-add__button--choose')?.replaceChildren(this.dataset.quickLabel);
          items.push(item);
        }
        if (!feed.dataset.next) break;
        next = new URL(feed.dataset.next, next);
        next.searchParams.set('section_id', 'dwil-collection-catalog');
        next.searchParams.set('sort_by', sort);
      }
      this.cache.set(key, items);
      return items;
    }
    async update(page = 1) {
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      const categories = Array.from(this.form.querySelectorAll('[name="category"]:checked'));
      const availability = Array.from(this.form.querySelectorAll('[name="availability"]:checked')).map(input => input.value);
      const sale = this.form.querySelector('[name="sale"]:checked');
      const sources = new Set(categories.map(input => input.dataset.collection).filter(Boolean));
      const tags = categories.filter(input => !input.dataset.collection).map(input => input.dataset.tag);
      if (!sources.size || tags.length) sources.add(this.dataset.source);
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[data-error-message]').hidden = true;
      this.querySelectorAll('.dc-catalog-pagination button').forEach(button => { button.disabled = true; });
      try {
        const merged = new Map();
        const collectionIds = new Set();
        for (const source of sources) {
          const cards = await this.loadCollection(source, this.sort.value, request.signal);
          const wholeCollection = !categories.length || categories.some(input => input.dataset.collection === source);
          for (const card of cards) {
            if (wholeCollection) collectionIds.add(card.dataset.id);
            merged.set(card.dataset.id, card);
          }
        }
        if (request.signal.aborted) return;
        let results = Array.from(merged.values()).filter(card => {
          const data = card.dataset;
          return (!categories.length || collectionIds.has(data.id) || tags.some(tag => JSON.parse(data.tags).includes(tag))) &&
            (!availability.length || availability.includes(data.available)) && (!sale || data.sale === 'true');
        });
        const order = this.sort.value;
        if (order.startsWith('price-')) results.sort((a,b) => (Number(a.dataset.price)-Number(b.dataset.price)) * (order.endsWith('descending') ? -1 : 1));
        if (order.startsWith('title-')) results.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title) * (order.endsWith('descending') ? -1 : 1));
        if (order.startsWith('created-')) results.sort((a,b) => (Number(a.dataset.date)-Number(b.dataset.date)) * (order.endsWith('descending') ? -1 : 1));
        this.results = results;
        this.total = results.length;
        this.page = page;
        this.querySelector('[data-active-count]').textContent = this.form.querySelectorAll('input:checked').length;
        this.render();
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          const message = this.querySelector('[data-error-message]');
          message.textContent = this.dataset.error;
          message.hidden = false;
          this.updatePagination();
        }
      } finally { if (this.request === request) this.removeAttribute('aria-busy'); }
    }
    changePage(delta) {
      const next = this.page + delta;
      if (next < 1 || next > Math.ceil(this.total / this.size)) return;
      if (next * this.size > this.results.length && this.results.length < this.total) this.update(next);
      else { this.page = next; this.render(); }
    }
    render() {
      const cards = this.results.slice((this.page - 1) * this.size, this.page * this.size);
      this.top.replaceChildren(...cards.slice(0,3));
      this.bottom.replaceChildren(...cards.slice(3));
      this.querySelector('[data-result-count]').textContent = this.total + ' ' + this.dataset.countLabel;
      this.querySelector('[data-empty]').hidden = this.total !== 0;
      this.bottom.hidden = cards.length <= 3;
      this.updatePagination();
    }
    updatePagination() {
      const pages = Math.max(1, Math.ceil(this.total / this.size));
      this.querySelector('.dc-catalog-pagination').hidden = pages <= 1;
      this.querySelector('[data-page-count]').textContent = this.page + ' / ' + pages;
      this.querySelector('[data-previous]').disabled = this.page <= 1;
      this.querySelector('[data-catalog-next]').disabled = this.page >= pages;
    }
    disconnectedCallback() { this.cleanup?.abort(); this.request?.abort(); this.initialized = false; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwil-collection-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dwil-collection-products')){customElements.define('dwil-collection-products',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.abort=new AbortController();const initialize=()=>{if(this.isConnected)this.initialize();};if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initialize,{once:true,signal:this.abort.signal});}else{queueMicrotask(initialize);}}initialize(){this.setAttribute('data-ready','');this.abort?.abort();this.abort=new AbortController();this.querySelector('select[name="sort_by"]')?.addEventListener('change',e=>e.target.form.requestSubmit(),{signal:this.abort.signal});}disconnectedCallback(){this.abort?.abort();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwil-collection-showcase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dwil-collection-scenes')){customElements.define('dwil-collection-scenes',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.abort=new AbortController();const initialize=()=>{if(this.isConnected)this.initialize();};if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initialize,{once:true,signal:this.abort.signal});}else{queueMicrotask(initialize);}}initialize(){this.abort?.abort();this.abort=new AbortController();this.index=0;this.scenes=[...this.querySelectorAll('[data-scene]')];this.setAttribute('data-ready','');this.addEventListener('click',e=>{const next=e.target.closest('[data-next]'),prev=e.target.closest('[data-prev]');if(next||prev){this.index=Math.max(0,Math.min(this.scenes.length-1,this.index+(next?1:-1)));this.update();const active=this.scenes[this.index];const focus=active?.querySelector(next?'[data-next]':'[data-prev]');(focus?.disabled?active?.querySelector(next?'[data-prev]':'[data-next]'):focus)?.focus({preventScroll:true});}},{signal:this.abort.signal});this.addEventListener('shopify:block:select',e=>{const i=this.scenes.findIndex(s=>s===e.target||s.contains(e.target));if(i>=0){this.index=i;this.update();}},{signal:this.abort.signal});this.update();}update(){this.scenes.forEach((s,i)=>{s.hidden=i!==this.index;s.querySelector('[data-prev]').disabled=this.index===0;s.querySelector('[data-next]').disabled=this.index===this.scenes.length-1;s.querySelector('[data-scene-count]').textContent=(this.index+1)+' / '+this.scenes.length;});}disconnectedCallback(){this.abort?.abort();}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwil-pdp-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dwil-pdp-anchor-nav')) {
    customElements.define(
      'dwil-pdp-anchor-nav',
      class DwilPdpAnchorNav extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;

          this.abortController = new AbortController();
          this.links = Array.from(this.querySelectorAll('[data-anchor-link]'));
          this.list = this.querySelector('[data-anchor-list]');
          this.extraOffset = Number.parseInt(this.dataset.extraOffset || '12', 10) || 0;
          this.targets = [];

          this.links.forEach((link) => {
            link.addEventListener('click', this.handleClick, { signal: this.abortController.signal });
          });

          window.addEventListener('resize', this.handleResize, {
            passive: true,
            signal: this.abortController.signal,
          });
          window.addEventListener('hashchange', this.handleHashChange, {
            signal: this.abortController.signal,
          });
          window.addEventListener('scroll', this.handleScroll, {
            passive: true,
            signal: this.abortController.signal,
          });
          const pageWrapper = this.closest('.page-wrapper') || document.querySelector('.page-wrapper');
          pageWrapper?.addEventListener('scroll', this.handleScroll, {
            passive: true,
            signal: this.abortController.signal,
          });
          document.addEventListener('shopify:block:select', this.handleBlockSelect, {
            signal: this.abortController.signal,
          });
          document.addEventListener('shopify:section:load', this.handleSectionLoad, {
            signal: this.abortController.signal,
          });
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.handleDocumentReady, {
              once: true,
              signal: this.abortController.signal,
            });
          }

          this.refreshTargets();
          this.setupObserver();
          this.syncFromHash();
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.observer?.disconnect();
          window.cancelAnimationFrame(this.resizeFrame || 0);
          window.cancelAnimationFrame(this.scrollFrame || 0);
          this.abortController = null;
        }

        handleClick = (event) => {
          const link = event.currentTarget;
          const targetId = link.dataset.anchorTarget || '';
          const target = this.targets.find((entry) => entry.link === link)?.target
            || this.resolveTarget(targetId);
          if (!target) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          const scrollContainer = this.getScrollContainer();
          const targetRect = target.getBoundingClientRect();
          const offset = this.getScrollOffset();
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const behavior = reduceMotion ? 'auto' : 'smooth';

          if (
            scrollContainer
            && scrollContainer !== document.documentElement
            && scrollContainer !== document.body
          ) {
            const containerRect = scrollContainer.getBoundingClientRect();
            const top = scrollContainer.scrollTop + targetRect.top - containerRect.top - offset;
            scrollContainer.scrollTo({ top: Math.max(0, top), behavior });
          } else {
            const top = window.scrollY + targetRect.top - offset;
            window.scrollTo({ top: Math.max(0, top), behavior });
          }

          window.history.pushState(null, '', link.getAttribute('href'));
          this.setActive(link);
        };

        handleResize = () => {
          window.cancelAnimationFrame(this.resizeFrame || 0);
          this.resizeFrame = window.requestAnimationFrame(() => this.setupObserver());
        };

        handleScroll = () => {
          window.cancelAnimationFrame(this.scrollFrame || 0);
          this.scrollFrame = window.requestAnimationFrame(this.handleIntersections);
        };

        handleDocumentReady = () => {
          this.refreshTargets();
          this.setupObserver();
          this.syncFromHash();
        };

        handleSectionLoad = () => {
          this.refreshTargets();
          this.setupObserver();
          this.syncFromHash();
        };

        handleHashChange = () => {
          this.syncFromHash();
        };

        handleBlockSelect = (event) => {
          const item = event.target?.closest?.('[data-anchor-item]');
          const link = item?.querySelector?.('[data-anchor-link]');
          if (link && this.contains(link)) this.setActive(link);
        };

        resolveTarget(targetId) {
          if (!targetId) return null;

          const exactTarget = document.getElementById(targetId);
          if (exactTarget) return exactTarget;
          if (targetId !== 'dwil-reviews') return null;

          return document.querySelector(
            '#judgeme_product_reviews[data-widget-name="review_widget"], '
            + '.jdgm-review-widget[data-widget-name="review_widget"], '
            + '#judgeme_product_reviews, '
            + '.jdgm-review-widget'
          );
        }

        refreshTargets() {
          this.targets = [];

          this.links.forEach((link) => {
            const targetId = link.dataset.anchorTarget || '';
            const target = this.resolveTarget(targetId);
            const item = link.closest('[data-anchor-item]');

            if (!target) {
              link.removeAttribute('aria-current');
              if (window.Shopify?.designMode) {
                if (item) item.hidden = false;
                link.setAttribute('aria-disabled', 'true');
              } else if (item) {
                item.hidden = true;
              }
              return;
            }

            if (item) item.hidden = false;
            link.removeAttribute('aria-disabled');
            this.targets.push({ link, target, targetId });
          });

          this.hidden = this.targets.length === 0 && !window.Shopify?.designMode;
        }

        getScrollContainer() {
          const pageWrapper = this.closest('.page-wrapper') || document.querySelector('.page-wrapper');
          if (pageWrapper) {
            const overflowY = window.getComputedStyle(pageWrapper).overflowY;
            if (overflowY === 'auto' || overflowY === 'scroll') return pageWrapper;
          }

          return document.scrollingElement;
        }

        getScrollOffset() {
          const headerHeight = Number.parseFloat(
            window.getComputedStyle(document.body).getPropertyValue('--header-height')
          ) || 0;
          return headerHeight + this.getBoundingClientRect().height + this.extraOffset;
        }

        setupObserver() {
          this.observer?.disconnect();
          if (this.targets.length === 0) return;

          const offset = Math.round(this.getScrollOffset());
          const scrollContainer = this.getScrollContainer();
          const observerRoot = (
            scrollContainer
            && scrollContainer !== document.documentElement
            && scrollContainer !== document.body
          ) ? scrollContainer : null;
          this.observer = new IntersectionObserver(this.handleIntersections, {
            root: observerRoot,
            rootMargin: `-${offset}px 0px -62% 0px`,
            threshold: [0, 0.01, 0.5],
          });
          this.targets.forEach(({ target }) => this.observer.observe(target));
        }

        handleIntersections = () => {
          const offset = this.getScrollOffset();
          let current = this.targets[0];

          this.targets.forEach((entry) => {
            if (entry.target.getBoundingClientRect().top <= offset + 4) current = entry;
          });

          this.setActive(current.link);
        };

        syncFromHash() {
          const targetId = window.location.hash.replace(/^#/, '');
          const match = this.targets.find((entry) => entry.targetId === targetId);
          if (match) this.setActive(match.link);
        }

        setActive(activeLink) {
          this.links.forEach((link) => {
            if (link === activeLink) {
              link.setAttribute('aria-current', 'location');
            } else {
              link.removeAttribute('aria-current');
            }
          });

          if (!this.list || !activeLink) return;
          const left = activeLink.offsetLeft - (this.list.clientWidth - activeLink.offsetWidth) / 2;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.list.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwil-pdp-color-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dwil-color-preview')) {
    customElements.define('dwil-color-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || !this.querySelector('[data-media]')) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.sequence = (this.sequence || 0) + 1;
        const initialSequence = this.sequence;
        this.color = this.dataset.initialIndex;
        this.scene = '1';
        this.media = this.querySelector('[data-media]');
        this.stage = this.querySelector('.dwil-color-preview__stage');
        this.status = this.querySelector('[data-status]');
        this.overlay = this.querySelector('[data-overlay]');
        this.message = this.querySelector('[data-load-message]');
        this.retry = this.querySelector('[data-retry]');
        this.colors = [...this.querySelectorAll('input[data-color-name]')];
        this.colors.forEach(input => { input.checked = input.value === this.color; });
        this.querySelectorAll('[data-controls]').forEach(field => { field.disabled = false; });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-color-name]')) this.color = event.target.value;
          else if (event.target.matches('[data-scene]')) this.scene = event.target.value;
          else return;
          this.showSelection();
        }, options);
        this.retry.addEventListener('click', () => this.showSelection(), options);
        this.addEventListener('shopify:block:select', event => {
          const label = [...this.querySelectorAll('[data-color-block]')].find(item => item.dataset.colorBlock === event.detail.blockId);
          const input = label?.querySelector('input');
          if (input) { input.checked = true; this.color = input.value; this.showSelection(); }
        }, options);
        const initialImage = this.media.querySelector('img');
        if (initialImage) {
          const onError = () => {
            if (this.sequence !== initialSequence) return;
            this.overlay.hidden = false;
            this.message.textContent = this.dataset.error;
            this.retry.hidden = false;
          };
          initialImage.addEventListener('error', onError, options);
          if (initialImage.complete && !initialImage.naturalWidth) onError();
        }
      }
      async showSelection() {
        const sequence = ++this.sequence;
        const selected = this.colors.find(input => input.value === this.color);
        const template = this.querySelector(`template[data-preview-key="${this.color}-${this.scene}"]`);
        if (!selected || !template) return;
        const name = selected.dataset.colorName;
        this.querySelector('[data-current-name]').textContent = name;
        this.status.textContent = '';
        this.retry.hidden = true;
        const source = template.content.querySelector('img');
        const image = source ? document.importNode(source, true) : null;
        this.overlay.hidden = !image;
        this.stage.setAttribute('aria-busy', String(Boolean(image)));
        this.message.textContent = `${this.dataset.loading} ${name}`;
        try {
          if (image) {
            image.loading = 'eager';
            await new Promise((resolve, reject) => {
              const timeout = setTimeout(() => reject(new Error('Image timeout')), 15000);
              image.onload = () => { clearTimeout(timeout); resolve(); };
              image.onerror = () => { clearTimeout(timeout); reject(new Error('Image failed')); };
              if (image.complete) {
                clearTimeout(timeout);
                if (image.naturalWidth) resolve(); else reject(new Error('Image failed'));
              }
            });
            if (image.decode) await image.decode();
          }
          if (sequence !== this.sequence || !this.isConnected) return;
          this.media.replaceChildren(...(image ? [image] : []));
          this.stage.dataset.kind = template.dataset.kind;
          this.querySelector('[data-empty]').hidden = Boolean(image);
          const caption = template.dataset.kind === 'scene' ? this.dataset.sceneLabel : template.dataset.kind === 'product' ? this.dataset.productLabel : this.dataset.emptyLabel;
          this.status.textContent = `${caption} · ${name}`;
          this.overlay.hidden = true;
        } catch {
          if (sequence !== this.sequence || !this.isConnected) return;
          this.message.textContent = this.dataset.error;
          this.status.textContent = this.dataset.error;
          this.retry.hidden = false;
        } finally {
          if (sequence === this.sequence) this.stage.setAttribute('aria-busy', 'false');
        }
      }
      disconnectedCallback() {
        this.sequence = (this.sequence || 0) + 1;
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dwil-pdp-project-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dwil-project-gallery')) {
    customElements.define('dwil-project-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.dwil-projects__track');
        this.dialog = this.querySelector('dialog');
        this.stage = this.querySelector('[data-project-stage]');
        this.details = this.querySelector('[data-project-details]');
        const previous = this.querySelector('[data-project-prev]');
        const next = this.querySelector('[data-project-next]');
        const navigation = this.querySelector('[data-project-navigation]');
        const update = () => {
          const overflow = this.track.scrollWidth - this.track.clientWidth;
          navigation.hidden = overflow < 2;
          previous.disabled = this.track.scrollLeft < 2;
          next.disabled = this.track.scrollLeft >= overflow - 2;
        };
        const move = direction => {
          const card = this.track.querySelector('article');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-project-open]');
          if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const card = trigger.closest('[data-project-card]');
          this.opener = trigger;
          this.stage.replaceChildren(card.querySelector('template').content.cloneNode(true));
          const copy = card.querySelector('[data-project-copy]');
          this.details.replaceChildren(...(copy.textContent.trim() ? [copy.cloneNode(true)] : []));
          this.dialog.showModal();
          this.querySelector('[data-project-close]').focus();
          const video = this.stage.querySelector('video');
          if (video) video.play().catch(() => { /* Native controls remain available when playback is blocked. */ });
        }, options);
        this.querySelector('[data-project-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.clearMedia();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const card = event.target.closest('article');
          if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'instant' });
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      clearMedia() {
        this.stage.querySelectorAll('video').forEach(video => {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          video.load();
        });
        this.stage.replaceChildren();
        this.details.replaceChildren();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.dialog?.open) this.dialog.close();
        if (this.stage) this.clearMedia();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
